var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_c('b-container',{staticClass:"p-4"},[(_vm.isLoading)?_c('loader'):_vm._e(),_c('router-view')],1),_c('scroll-to-top',{attrs:{"threshold":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }